(() => {
  const MAX = Number(window.__MAX_QTY_PER_ITEM__ || 5);

  const toInt = (v) => {
    const n = parseInt(String(v ?? "").replace(/[^\d-]/g, ""), 10);
    return Number.isFinite(n) ? n : 1;
  };

  const clamp = (n, min, max) => Math.max(min, Math.min(max, toInt(n)));
  const clampAdd = (n) => clamp(n, 1, MAX);     // /cart/add
  const clampUpd = (n) => clamp(n, 0, MAX);     // /cart/change, /cart/update (permite 0 pt remove)

  const isCartEndpoint = (url) =>
    typeof url === "string" &&
    (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update"));

  const pickClamp = (url) =>
    String(url || "").includes("/cart/add") ? clampAdd : clampUpd;

  const clampObjectPayload = (url, obj) => {
    const clampFn = pickClamp(url);
    if (!obj || typeof obj !== "object") return obj;

    // { quantity: x }
    if ("quantity" in obj) obj.quantity = clampFn(obj.quantity);

    // { items: [{id, quantity}] }
    if (Array.isArray(obj.items)) {
      obj.items = obj.items.map((it) => {
        if (!it || typeof it !== "object") return it;
        if ("quantity" in it) return { ...it, quantity: clampFn(it.quantity) };
        return it;
      });
    }

    // { updates: { variantId: qty, ... } }
    if (obj.updates && typeof obj.updates === "object" && !Array.isArray(obj.updates)) {
      const next = {};
      for (const [k, v] of Object.entries(obj.updates)) {
        next[k] = clampFn(v);
      }
      obj.updates = next;
    }

    // unele teme trimit updates[] / quantities ca array
    if (Array.isArray(obj.updates)) {
      obj.updates = obj.updates.map((v) => clampFn(v));
    }

    return obj;
  };

  const clampUrlEncoded = (url, str) => {
    const clampFn = pickClamp(url);
    const p = new URLSearchParams(str);

    if (p.has("quantity")) p.set("quantity", String(clampFn(p.get("quantity"))));

    // items[0][quantity] etc
    for (const [k, v] of Array.from(p.entries())) {
      if (/\[quantity\]$/.test(k)) p.set(k, String(clampFn(v)));
    }

    // updates[] in cart form (allow 0)
    // (nu trebuie altceva, clampFn deja permite 0 pt update endpoints)
    if (p.has("updates[]")) p.set("updates[]", String(clampFn(p.get("updates[]"))));

    return p.toString();
  };

  const clampBody = (url, body) => {
    if (!body) return body;

    // FormData
    if (body instanceof FormData) {
      const clampFn = pickClamp(url);
      if (body.has("quantity")) body.set("quantity", String(clampFn(body.get("quantity"))));
      for (const key of Array.from(body.keys())) {
        if (/\[quantity\]$/.test(key)) body.set(key, String(clampFn(body.get(key))));
      }
      if (body.has("updates[]")) body.set("updates[]", String(clampFn(body.get("updates[]"))));
      return body;
    }

    // URLSearchParams
    if (body instanceof URLSearchParams) {
      return new URLSearchParams(clampUrlEncoded(url, body.toString()));
    }

    // String
    if (typeof body === "string") {
      const t = body.trim();

      // 1) JSON FIRST (asta era problema la tine)
      if (t.startsWith("{") || t.startsWith("[")) {
        try {
          const obj = JSON.parse(body);
          const next = clampObjectPayload(url, obj);
          return JSON.stringify(next);
        } catch {
          // dacă nu e JSON valid, cădem mai jos
        }
      }

      // 2) urlencoded doar dacă arată ca urlencoded (are "=")
      if (body.includes("=")) {
        try {
          return clampUrlEncoded(url, body);
        } catch {
          return body;
        }
      }

      return body;
    }

    // Object (rar)
    try {
      const copy = structuredClone(body);
      return clampObjectPayload(url, copy);
    } catch {
      return body;
    }
  };

  // Clamp la submit doar pt /cart/add
  document.addEventListener(
    "submit",
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = (form.getAttribute("action") || "").toLowerCase();
      if (!action.includes("/cart/add")) return;

      const qty = form.querySelector('input[name="quantity"]');
      if (qty) qty.value = String(clampAdd(qty.value));

      form.querySelectorAll('input[name$="[quantity]"]').forEach((i) => {
        i.value = String(clampAdd(i.value));
      });
    },
    true
  );

  // Patch fetch
  const origFetch = window.fetch?.bind(window);
  if (origFetch) {
    window.fetch = (input, init = {}) => {
      const url = typeof input === "string" ? input : input?.url || "";
      if (isCartEndpoint(url) && init?.body) {
        init = { ...init, body: clampBody(url, init.body) };
      }
      return origFetch(input, init);
    };
  }

  // Patch XHR
  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__qtyLimitUrl = url;
    return origOpen.call(this, method, url, ...rest);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (isCartEndpoint(this.__qtyLimitUrl) && body) {
      body = clampBody(this.__qtyLimitUrl, body);
    }
    return origSend.call(this, body);
  };

  // UI clamp (doar taie > MAX; nu bloca 0 în cart)
  const bindInputs = (root = document) => {
    root
      .querySelectorAll('input[name="quantity"], input[name="updates[]"]')
      .forEach((input) => {
        if (input.__qtyLimitBound) return;
        input.__qtyLimitBound = true;
        input.setAttribute("max", String(MAX));

        input.addEventListener("change", () => {
          const val = toInt(input.value);
          if (val > MAX) input.value = String(MAX);
        });
      });
  };

  const init = () => {
    bindInputs();
    const obs = new MutationObserver(() => bindInputs());
    obs.observe(document.documentElement, { childList: true, subtree: true });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
